import { useState } from "react";
import { X, Copy, Check, Mail, KeyRound, LogIn } from "lucide-react";

export default function CredentialsDialog({ creds, title = "Portal login details", onClose }) {
  const [copied, setCopied] = useState("");
  if (!creds) return null;
  const who = creds.role || "user";
  const copy = async (key, val) => {
    try { await navigator.clipboard.writeText(val); } catch { /* insecure context */ }
    setCopied(key);
    setTimeout(() => setCopied(""), 1500);
  };
  const Row = ({ id, label, value, icon: Icon }) => (
    <div className="flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2">
      <Icon size={15} className="text-slate-400 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-[10px] uppercase tracking-wide text-slate-400">{label}</p>
        <p className="text-sm font-medium text-slate-800 truncate" data-testid={`cred-${id}`}>{value}</p>
      </div>
      <button type="button" onClick={() => copy(id, value)} data-testid={`copy-${id}`} className="text-slate-400 hover:text-blue-600 shrink-0" title="Copy">
        {copied === id ? <Check size={15} className="text-emerald-600" /> : <Copy size={15} />}
      </button>
    </div>
  );
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm" onClick={onClose}>
      <div data-testid="credentials-dialog" className="bg-white rounded-2xl shadow-xl border border-slate-200 w-full max-w-md p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-1">
          <h3 className="font-display text-xl font-bold text-slate-900">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-700"><X size={20} /></button>
        </div>
        <p className="text-sm text-slate-500 mb-4">
          Share these with the {who}. {creds.emailed ? "A copy has also been emailed to them." : "The email could not be sent — please share these manually."}
        </p>
        <div className="space-y-2">
          <Row id="email" label="Login email" value={creds.email} icon={Mail} />
          {creds.temp_password
            ? <Row id="password" label="Temporary password" value={creds.temp_password} icon={KeyRound} />
            : <p className="text-xs text-slate-400 px-1">This account already existed — its password was left unchanged. Use “Reset password” to issue a new one.</p>}
          <Row id="link" label="Portal login link" value={creds.login_url} icon={LogIn} />
        </div>
        <p className="text-xs text-slate-400 mt-4">The {who} can change this password after their first login.</p>
        <button onClick={onClose} data-testid="credentials-done" className="w-full mt-4 bg-blue-700 text-white hover:bg-blue-800 rounded-lg px-4 py-2.5 font-medium">Done</button>
      </div>
    </div>
  );
}
